import axios from 'axios';

const api = axios.create({
  baseURL: 'https://voltipay.api.dev3.net-page.ru/',
});

export default api;
